import axios from 'axios';
import authHeader from './auth-header';
import CommonServices from './common.service';

const API_URL = CommonServices.getApiUrl() + 'config/';

class ConfigService {

  getConfig() {
    return axios.get(API_URL, { headers: authHeader() });
  }

  // values: { key: value, ... } — only changed keys need be sent.
  saveConfig(values) {
    return axios.put(API_URL, { values }, { headers: authHeader() });
  }

  restartMcp() {
    return axios.post(API_URL + 'mcp/restart', {}, { headers: authHeader() });
  }
}

export default new ConfigService();
